// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAccountCloseMessage
 */
export interface IAccountCloseMessage {
    /**
     * 
     * @type {number}
     * @memberof IAccountCloseMessage
     */
    account_id: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountCloseMessage
     */
    employee_id: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountCloseMessage
     */
    payment_method_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAccountCloseMessage
     */
    return_type: string;
    /**
     * 
     * @type {number}
     * @memberof IAccountCloseMessage
     */
    contact_id?: number;
}

/**
 * Check if a given object implements the IAccountCloseMessage interface.
 */
export function instanceOfIAccountCloseMessage(value: object): value is IAccountCloseMessage {
    if (!('account_id' in value) || value['account_id'] === undefined) return false;
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    if (!('return_type' in value) || value['return_type'] === undefined) return false;
    return true;
}

export function IAccountCloseMessageFromJSON(json: any): IAccountCloseMessage {
    return IAccountCloseMessageFromJSONTyped(json, false);
}

export function IAccountCloseMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountCloseMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'account_id': json['account_id'],
        'employee_id': json['employee_id'],
        'payment_method_id': json['payment_method_id'] == null ? undefined : json['payment_method_id'],
        'return_type': json['return_type'],
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
    };
}

export function IAccountCloseMessageToJSON(json: any): IAccountCloseMessage {
    return IAccountCloseMessageToJSONTyped(json, false);
}

export function IAccountCloseMessageToJSONTyped(value?: IAccountCloseMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id': value['account_id'],
        'employee_id': value['employee_id'],
        'payment_method_id': value['payment_method_id'],
        'return_type': value['return_type'],
        'contact_id': value['contact_id'],
    };
}

